import Ouvidoria from "@/pages/ouvidoria/index.vue";
import List from "@/pages/ouvidoria/list.vue";
import Revision from "@/pages/ouvidoria/revisao.vue";
import uploadFile from "@/pages/ouvidoria/upload-file.vue";
import Protocol from "@/pages/ouvidoria/protocol.vue";
import Term from "@/pages/ouvidoria/term.vue";
import DetailProtocol from "@/pages/ouvidoria/detail.vue";

const routes: Route[] = [
  {
    path: "/ouvidoria",
    component: Ouvidoria,
    children: [
      {
        path: "",
        component: List,
        meta: {
          backTo: "/",
          validPath: ["/ouvidoria"]
        }
      },
      {
        path: "criar/termo",
        component: Term,
        meta: {
          backTo: "/ouvidoria",
          validPath: ["/ouvidoria"]
        }
      },
      {
        path: "criar/protocolo",
        component: Protocol,
        meta: {
          backTo: "/ouvidoria/criar/termo",
          validPath: ["/ouvidoria"]
        }
      },
      {
        path: "criar/revisao",
        component: Revision,
        meta: {
          backTo: "/ouvidoria/criar/protocolo",
          validPath: ["/ouvidoria"]
        }
      },
      {
        path: "criar/imagem-analise",
        component: uploadFile,
        meta: {
          backTo: "/ouvidoria/criar/revisao",
          validPath: ["/ouvidoria"]
        }
      },
      {
        path: "detalhe/:protocol",
        name: "detail.sac",
        component: DetailProtocol,
        meta: {
          backTo: "/ouvidoria",
          validPath: ["/ouvidoria"]
        }
      }
    ]
  }
];

export default routes;
